import { Info } from '@phosphor-icons/react';

import { formatEUR } from '../../utils/money';
import { cn } from '../../utils/cn';
import pt from '../../locales/pt';

/**
 * Cartão resumo — `.pen` `resumo · total típico` (frames `Fontes de
 * Rendimento · Normal`): total + barra segmentada por balde + legenda.
 */
export function IncomeSourcesSummaryCard({ totalEur = 0, groups = [], className }) {
  return (
    <section
      className={cn(
        'rounded-ds-xl border border-border bg-card p-space-5 shadow-[0_6px_16px] shadow-glass-shadow/[0.12] dark:shadow-glass-shadow/[0.45]',
        className,
      )}
    >
      <div className="flex flex-col gap-space-1">
        <div className="flex items-center gap-1.5">
          <span className="type-section text-muted-foreground">
            {pt.income.sources.summaryCard.totalLabel}
          </span>
          <Info className="h-3.5 w-3.5 text-muted-foreground" aria-hidden />
        </div>
        <span className="type-display-kpi text-card-foreground">{formatEUR(totalEur)}</span>
      </div>

      {totalEur > 0 ? (
        <div className="mt-space-4 flex flex-col gap-space-3">
          <div className="flex h-2 overflow-hidden rounded-full" aria-hidden>
            {groups.map(({ bucket, totalEur: bucketTotal }) => (
              <span
                key={bucket.id}
                className={bucket.tone.dot}
                style={{ width: `${(bucketTotal / totalEur) * 100}%` }}
              />
            ))}
          </div>
          <ul
            className="flex flex-col gap-1.5"
            aria-label={pt.income.sources.summaryCard.breakdownLabel}
          >
            {groups.map(({ bucket, totalEur: bucketTotal, label }) => (
              <li key={bucket.id} className="flex items-center justify-between gap-1.5">
                <span className="flex items-center gap-1.5">
                  <span className={cn('h-2 w-2 shrink-0 rounded-full', bucket.tone.dot)} aria-hidden />
                  <span className="type-label text-muted-foreground">{label}</span>
                </span>
                <span className="type-label font-bold tnum text-card-foreground">
                  {formatEUR(bucketTotal)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  );
}
